import type { PlayerVerticalSliceView } from '@aztec-realms/shared-types';

/** Navigation advice from the current snapshot; never an unlock or reward decision. */
export function realmNextStep(snapshot: PlayerVerticalSliceView) {
  const buildings = snapshot.settlement.buildings;
  const pending = buildings.find((building) => building.state === 'constructing');
  if (pending) {
    return {
      title:
        (pending.progress ?? 0) >= 1
          ? `Check your ${pending.label} completion`
          : `${pending.label} is under construction`,
      progressLabel:
        (pending.progress ?? 0) >= 1
          ? 'Open construction to confirm the completed result'
          : `${snapshot.settlement.construction.find((job) => job.buildingId === pending.id)?.remainingLabel ?? 'Building in progress'} · play while it grows`,
      href: `/home?panel=selected&building=${encodeURIComponent(pending.id)}`,
    };
  }
  const families = new Set(buildings.map((building) => building.type)).size;
  if (families < 10) {
    return {
      title: 'Grow your settlement',
      progressLabel: `${families} of 10 building families · choose your next building`,
      href: '/home?panel=build',
    };
  }
  const upgrade = buildings.find((building) => building.state === 'upgrade_available');
  if (upgrade) {
    return {
      title: `Develop your ${upgrade.label}`,
      progressLabel: 'New capabilities await your next upgrade',
      href: `/home?panel=selected&building=${encodeURIComponent(upgrade.id)}`,
    };
  }
  return {
    title: 'Discover another glyph family',
    progressLabel: 'Try a different stop · grow your collection',
    href: '/explore',
  };
}
